import { lpProfileUrl } from "../_lib/api";
import { VerifiedIcon } from "./icons";

// "Verified on Licensedproducer" — the agent's listing is active and linked
// to this account. Click-through to their public profile there.
export function VerifiedBadge({ slug, className = "h-3 w-3", withLabel = false }: { slug: string; className?: string; withLabel?: boolean }) {
  return (
    <a
      href={lpProfileUrl(slug)}
      target="_blank"
      rel="noopener noreferrer"
      title="Verified on Licensedproducer. Opens their profile."
      aria-label="Verified on Licensedproducer, opens their profile"
      className="fp-inline relative z-10 inline-flex items-center gap-1 align-middle text-blue-600 hover:text-blue-800"
    >
      <VerifiedIcon className={className} />
      {withLabel && <span className="text-[12px] font-semibold">Verified agent</span>}
    </a>
  );
}
